import { useEffect } from "react";

type pdfViewerProps = {
    pdfURL: string;
};
const PdfViewer = ({ pdfURL }: pdfViewerProps) => {
    useEffect(() => {
        const downloadUrl = `${pdfURL}&force_download=true`;
        const anchor = document.createElement("a");
        anchor.href = downloadUrl;
        anchor.download = "";
        anchor.style.display = "none";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }, [pdfURL]);

    return (
        <>
            <div style={{ width: "100%", height: "100vh" }}>
                <iframe
                    title={pdfURL}
                    src={pdfURL}
                    width="100%"
                    height="100%"
                />
            </div>
        </>
    );
};
export default PdfViewer;
